

let settings = {};

function onSwymLoadCallback(swat) {
    // Please make all SWYM-related API calls inside this function.
    // You can use the swat argument within this scope.


  let accountBtn = document.querySelector('.nh-login-link');
  let userLoggedOut = accountBtn.textContent.indexOf('Login');
  console.log('Login Status: '+userLoggedOut);




  function displayError( title = '', msg ){

  const closeBtn = '<div class="nh-close-btn"><button type="button"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0.533564" y1="12.412" x2="11.7922" y2="1.15341" stroke="black" stroke-width="0.8"/><line x1="0.282843" y1="0.717157" x2="11.5415" y2="11.9758" stroke="black" stroke-width="0.8"/></svg></button></div>';

  let modalBackground = document.createElement('div');
  modalBackground.classList.add('nh-modal-background');
  document.body.appendChild(modalBackground);

  setTimeout(() => {
    modalBackground.classList.add('visible');
    document.body.classList.add('noscroll');
  }, 50);

  let modal = document.createElement('div');
  modal.classList.add('nh-modal-content','nh-error-content');
  modal.innerHTML += closeBtn;

  if ( title == '' ){
    let heading = 'Error';
  } else {
    heading = title;
  }

  let message =
  '<div class="form-holder">'+
  '<h2>'+heading+'</h2>'+
  '<p class="message">'+msg+'</p>'+
  '</div>';

  modal.innerHTML += message;
  modal.innerHTML += '<div class="nh-button-holder">'+
  '<button class="nh-button nh-button--calypso white-bg"><span>Close</span></button>'+
  '</div>';


  modalBackground.appendChild(modal);


  modalBackground.addEventListener('click', (e) => {
    if ( e.target.closest('.nh-modal-content') == null ){

      let modalBackground = document.querySelector('.nh-modal-background');
      if ( modalBackground != null ){
        modalBackground.classList.remove('visible');
        setTimeout( () => {

          modalBackground.remove();
          document.body.classList.remove('noscroll');
        }, 210 );
      }

    }
  });

  let modalCloseBtns = document.querySelectorAll('.nh-modal-content .nh-close-btn,.nh-modal-content .nh-button');
  [].forEach.call(modalCloseBtns, function( btn ) {
    btn.addEventListener('click', () => {
      if ( modalBackground != null ){
        modalBackground.classList.remove('visible');
        setTimeout( () => {

          modalBackground.remove();
          document.body.classList.remove('noscroll');
        }, 210 );
      }
    });
  });
  /*
  let modalClose = document.querySelector('.nh-modal-content .nh-close-btn');
  modalClose?.addEventListener('click', () => {
    if ( modalBackground != null ){
      modalBackground.classList.remove('visible');
      setTimeout( () => {

        modalBackground.remove();
        document.body.classList.remove('noscroll');
      }, 210 );
    }

  });*/
}

    if (swat) {

      console.log('swat exists');

      document.body.addEventListener('click', (e) => {

        if ( e.target.closest('.nh-thumb-wishlist') != null && !document.body.classList.contains('wishlist-page')){

          let btn = e.target.closest('.nh-thumb-wishlist');

          // wishlist thumbnail code here
          if ( btn.classList.contains('inlist') ){

            let productObj = {
              du: 'https://' + window.location.hostname + btn.getAttribute('data-url'),
              epi: btn.getAttribute('data-vid'),
              empi: btn.getAttribute('data-pid')
            };

            //bku: back here
            let lid = wishLists[0].lid;

            removeProduct(productObj, btn)

          } else {
            console.log('adding to wishlist');
            addToWishlist( btn );
          }
        }
      });

      window.addEventListener('thumbnailsAdded', () => {
        console.log('new thumbnails added');
        let thumbs = document.querySelectorAll('.search-results-holder .nh-thumb-wishlist');

          [].forEach.call(thumbs, function( btn ) {
            let pid = btn.getAttribute('data-pid');
            let vid = btn.getAttribute('data-vid');
            wishLists[0].listcontents.forEach( (obj) => {

              if ( pid == obj.empi && vid == obj.epi){
                btn.classList.add('inlist');
              }

            });

            btn.addEventListener('click', (e) => {
              e.preventDefault();

              if ( btn.classList.contains('inlist') ){

                let productObj = {
                  du: 'https://' + window.location.hostname + btn.getAttribute('data-url'),
                  epi: btn.getAttribute('data-vid'),
                  empi: btn.getAttribute('data-pid')
                };

                //bku: back here
                let lid = wishLists[0].lid;

                removeProduct(productObj, btn)

              } else {

                addToWishlist( btn );
              }

            });

          });



      });

      window.addEventListener('variantChanged', () => {

        let productWishlistButton = document.querySelector('.nh-add-wishlist');
          if ( productWishlistButton != null ){
            //get selected variant ID
            let variantID = productWishlistButton.getAttribute('data-vid');
            let found = false;

            wishLists[0].listcontents.forEach( (obj) => {
              console.log(variantID+' => '+obj.epi);
              if ( variantID == obj.epi ){
                found = true;
              }
            });

            if ( found ){
              productWishlistButton.classList.add('inlist');
            } else {
              productWishlistButton.classList.remove('inlist');
            }
          }

      });

      let wishLists = [];
      let fpOptions = { mode: 'single' };
      let wishListProducts = null;
      let lid = null;


      function checkProductInLists(vid)
      {
        console.log('checking product');
        let found = false;
        for ( let x=0; x<wishLists.length; x++ ){

          let list = wishLists[x];
          for ( let n=0; n<list.listcontents.length; n++ ){
            if ( vid == list.listcontents[n].epi ){
              console.log( vid+' == '+list.listcontents[n].epi );
              found = true;
            }
          }
        }
        console.log(found);
        return found;
      }

      function createWishlist( wishListTitle ){

        // Define the list config
        let listConfig = {
          "lname": wishListTitle, // unique list name.
        };

        // Define success callback
        let onSuccess = function(newList) {
          // Executed when a new list is successfully created
          console.log("Successfully created a new List", newList);
        }

        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while creating a List", error);
        }

        // Create a new list with the above callbacks and config
        swat.createList(listConfig, onSuccess, onError);

      }

      function removeProduct(productObj, button)
      {

        let lid = wishLists[0].lid;
        button.disabled = true;
        // Define success callback
        let onSuccess = function(deletedProduct) {
          // Executed when product is successfully deleted
          console.log("Successfully deleted the Product", deletedProduct);
          button.disabled = false;
          button.classList.remove('inlist');
          getAllLists( {init:false} );
        }

        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          button.disabled = false;
          console.log("Error while deleting the Product", error);
        }

        // Call `deleteFromList` using the above callbacks, lid and listItem
        swat.deleteFromList(lid, productObj, onSuccess, onError);
      }

      /* init()
      * Description here
      */

      function init(){
        console.log('init() called');

        let opts = { init: true }
        getAllLists( opts );

        document.body.addEventListener('click', (e) => {

          if ( e.target.classList.contains('nh-add-wishlist') ){

            let btn = e.target;

            e.preventDefault();


            if ( wishLists.length < 1 ){
              createWishlist('My Wishlist');
              getAllLists( {init: false} );
            } else {
              //check if product is in wishlist


              if ( checkProductInLists( btn.getAttribute('data-vid') ) ){
                //remove product from wishlist

                let productObj = {
                  du: 'https://' + window.location.hostname + btn.getAttribute('data-url'),
                  epi: btn.getAttribute('data-vid'),
                  empi: btn.getAttribute('data-pid')
                };


                removeProduct( productObj, btn );

              } else {

                addToWishlist(btn);
              }
            }

          }
        });

      }
      init();


      /* showWishlistProducts()
      * will display products in a wishlist if the
      * wishlist page is being viewed by calling
      * getListItems()
      */

      function showWishlistProducts()
      {
        console.log('showWishlistProducts() called');
        const pathname = window.location.pathname;
        if ( pathname == '/pages/wishlist' ){

          console.log('length is '+wishLists.length);
          if ( wishLists.length > 0 ){
            let lid = wishLists[0].lid;
            getListItems( lid );
          }
        }
      }

      /* getListItems()
      * outputs the html for the wishlist page
      */

      function getListItems( lid )
      {
        console.log('getListItems() called');
        // define the list config
        let listConfig = {
          "lid": lid, // lid
        };

        // Define success callback
        let onSuccess = function(listContents) {
          // successfully fetched list contents
          console.log("Successfully fetched List Contents", listContents);
          wishListProducts = listContents;

          let productsHolder = document.querySelector('.nh-product-list');

          /*let shareButton = document.createElement('button');
          shareButton.classList.add('nh-share-wishlist');
          shareButton.textContent = 'Share';*/

          let string = '';

          if ( listContents.length < 1 ){
            string = '<p class="nh-wishlist-text">You have no wishlist items.</p>';
            productsHolder.innerHTML = string;
            //document.querySelector('.main-page-title').after(productsHolder);

          } else {
            document.querySelector('.nh-wishlist-page').classList.add('has-items');
            var lazyLoadInstance = new LazyLoad({
              // Your custom settings go here
              /*callback_loaded: (el) => {
                if ( el.closest('.nh-full-width-image') != null ){
                  let container = el.closest('.nh-full-width-image');
                  container.classList.add('visible');
                }
              }*/
            });

            // Format the price above to USD using the locale, style, and currency.
            let USDollar = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            });

            const svgHeart = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="16" fill="black"/><mask id="mask-h"><path d="M11.0288 2.5C9.00001 2.5 8.00001 4.5 8.00001 4.5C8.00001 4.5 7.00001 2.5 4.97126 2.5C3.32251 2.5 2.01689 3.87937 2.00001 5.52531C1.96564 8.94187 4.71033 11.3716 7.71876 13.4134C7.8017 13.4699 7.8997 13.5 8.00001 13.5C8.10033 13.5 8.19832 13.4699 8.28126 13.4134C11.2894 11.3716 14.0341 8.94187 14 5.52531C13.9831 3.87937 12.6775 2.5 11.0288 2.5Z" stroke="white" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" style="fill: #FFF;fill-opacity: 1;"/></mask><path d="M11.0286 2.50024C8.99996 2.50024 8.00001 4.50013 8.00001 4.50013C8.00001 4.50013 7.00007 2.50024 4.97143 2.50024C3.32278 2.50024 2.01722 3.87954 2.00035 5.52539C1.96598 8.94176 4.71051 11.3713 7.71878 13.4131C7.80172 13.4695 7.89971 13.4997 8.00001 13.4997C8.10032 13.4997 8.19831 13.4695 8.28125 13.4131C11.2892 11.3713 14.0337 8.94176 13.9997 5.52539C13.9828 3.87954 12.6773 2.50024 11.0286 2.50024Z" stroke="white" stroke-width="0.599966" stroke-linecap="round" stroke-linejoin="round"/><g mask="url(#mask-h)"><rect class="background" x="0" y="0" width="100" height="100"  fill="#FFFFFF"/></g></svg>';

            listContents.forEach( (obj) => {

                let productLink = '';
                let variantID = '';

                if ( obj.product.hasOwnProperty('vi') ){
                  productLink = obj.product.uri;
                } else {
                  productLink = obj.du;
                }


                string += '<div class="nh-product-thumb">';

                string += '<div class="nh-img"><a href="'+productLink+'"><img class="lazy" src="" data-src="'+obj.iu+'" alt="'+obj.dt+'"></a></div>';
                string += '<div class="nh-product-thumb-info">';
                string += '<div class="nh-wishlist-icon in-list"><div class="circle"></div><button class="nh-thumb-wishlist inlist" data-url="'+productLink+'" data-vid="'+obj.epi+'" data-pid="'+obj.empi+'" aria-label="Remove from Wishlist">'+svgHeart+'</button></div>';
                string += '<div class="nh-product-thumb-details"><p><a href="'+productLink+'">'+obj.dt;
                if ( obj.hasOwnProperty('vi') ){
                  string += '<br>'+obj.vi;
                }
                string += '</p>';
                string += '<p>'+USDollar.format(obj.pr)+'</p></div>';
                string += '</div><!-- .nh-product-thumb-info -->';
                string += '</div><!-- .nh-product-thumb -->';

              }
            );


            productsHolder.innerHTML += string;
            lazyLoadInstance.update();

            imagesLoaded(productsHolder, () => {

              let thumbs = productsHolder.querySelectorAll('.nh-product-thumb');

              for (let i = 0; i < thumbs.length; i++) {
                var delay = i * 200;
                window.setTimeout(function () {
                  thumbs[i].classList.add("visible");
                }, delay);
              }
            });

            //document.querySelector('.nh-before-thumbs').after(productsHolder);
            setTimeout( () => {
              let shareButton = document.querySelector('.nh-share-list');
              if ( shareButton != null ){
                shareButton.addEventListener('click', () => {


                    let loggedInStatus = shareButton.getAttribute('data-status');

                    if ( loggedInStatus == '0' ){


                      displayError('Notice','You need to <br><a href="/account/login">log in</a> <br>or <br><a href="/account/register">create an account</a> <br>to share your wishlist.');





                    } else {

                      showShareModal();

                      let form = document.querySelector('.nh-modal-content form');
                      if ( form != null ){
                        form.addEventListener('submit', (e) => {
                            e.preventDefault();
                            //validate input

                            function showError( obj ){
                              let error = document.createElement('span');
                              error.classList.add('nh-error');
                              error.textContent = 'This field is required';
                              obj.parentNode.appendChild(error);
                            }

                            let errorCount = 0;

                            if ( form.elements.sender_name.value == '' ){
                              showError( form.elements.sender_name );
                              errorCount++;
                            }

                            if ( form.elements.recipient_email.value == '' ){
                              showError( form.elements.recipient_email );
                              errorCount++;
                            }
                            if ( form.elements.message.value == '' ){
                              showError( form.elements.message );
                              errorCount++
                            }

                            if ( errorCount === 0 ){

                              // information required to send the email
                              let params = {
                              	toEmailId: form.elements.recipient_email.value, // To Email
                              	fromName: form.elements.sender_name.value, // From Name
                              	note: form.elements.message.value,  // Note
                              	lid: lid, // null when multiple list is not enabled
                              	cprops: {}, // custom props for the share, future usage
                              }

                              // Success Callback.
                              let onSuccess = function(response) {
                                let conf = document.createElement('div');
                                conf.classList.add('nh-confirmation');
                                conf.innerHTML = '<div class="modal-logo"><img src="https://cdn.shopify.com/s/files/1/0882/6011/6801/files/nh_collection_logo_25f7290f-ae90-408b-999f-bf0536862c02.png?v=1747426780" alt=""></div><p>Your wishlist has been sent</p>';

                                let modal = document.querySelector('.nh-modal-background .nh-modal-content');
                                if ( modal != null ){
                                  modal.appendChild(conf);
                                  setTimeout( () =>{
                                    conf.classList.add('visible');
                                  }, 50 )
                                }


                              	console.log("Successfully sent the wishlist contents via Email", response)
                              }

                              // Error Callback.
                              let onError = function(error) {
                                // Error is an xhrObject
                              	console.log("There was an Error Sending the email", error);
                              }

                              console.log(params);
                              // Send API
                              swat.sendListViaEmail(params, onSuccess, onError);
                            }


                        });
                      }

                    }
                });
              }
            }, 50 );



            let wishlistButtons = productsHolder.querySelectorAll('.nh-thumb-wishlist');
            if ( wishlistButtons != null ){
              [].forEach.call(wishlistButtons, function( btn ) {
                btn.addEventListener('click', () => {

                  btn.disabled = true;
                  let pageWipe = document.getElementById('page-wipe');
	                pageWipe.classList.add('visible');
                  let transitionEnded = false;

                  pageWipe.addEventListener('transitionend', () => {
                    transitionEnded = true;
                  });

                  /*function handleTransitions()
                  {

                    if ( pageWipe.classList.contains('visible') && !pageWipe.classList.contains('pull-up') ){
                      productDiv?.remove();
                      pageWipe.classList.add('pull-up');
                    } else if ( pageWipe.classList.contains('visible') && pageWipe.classList.contains('pull-up') ) {
                      pageWipe.classList.add('returning');
                      transitionEnded = false;
                      setTimeout(() => {
                        pageWipe.classList.remove('visible', 'pull-up', 'returning');
                      }, 50);
                    }
                    //////
                  }*/



                  let productObj = {
                    du: btn.getAttribute('data-url'),
                    epi: btn.getAttribute('data-vid'),
                    empi: btn.getAttribute('data-pid')
                  };

                  let lid = wishLists[0].lid;


                  // Define success callback
                  let onSuccess = function(deletedProduct) {
                    // Executed when product is successfully deleted
                    btn.disabled = false;
                    refreshLists();
                    let productDiv = btn.closest('.nh-product-thumb');
                    productDiv?.remove();
                    pageWipe.classList.add('pull-up');

                    setTimeout( () => {
                      pageWipe.classList.add('returning');
                      setTimeout(() => {
                        pageWipe.classList.remove('visible', 'pull-up', 'returning');
                      }, 50);
                    }, 840 );

                  }

                  // Define error callback
                  let onError = function(error) {
                  	// Error is an xhrObject
                  	console.log("Error while deleting the Product", error);
                    btn.disabled = false;

                    pageWipe.classList.add('pull-up');

                    setTimeout( () => {
                      pageWipe.classList.add('returning');
                      setTimeout(() => {
                        pageWipe.classList.remove('visible', 'pull-up', 'returning');
                      }, 50);
                    }, 840 );

                  }

                  // Call `deleteFromList` using the above callbacks, lid and listItem
                  setTimeout( () => {
                    swat.deleteFromList(lid, productObj, onSuccess, onError);
                  },850 );


                });
              });
            }
          }





        }

        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error fetching List Contents", error);
        }

        swat.fetchListCtx(listConfig, onSuccess, onError);
      }

      /* hideShareModal()
      *
      */

      function hideShareModal()
      {
        let modalBackground = document.querySelector('.nh-modal-background');
        if ( modalBackground != null ){
          modalBackground.classList.remove('visible');
          setTimeout( () => {
            modalBackground.remove();
          }, 210 );
        }
      }

      /* showShareModal()
      *
      */

      function showShareModal(){


        function resetInputs()
        {
        	var inputs = document.querySelectorAll('form input');
        	var inputNum = inputs.length;
            for ( var x=0; x<inputNum; x++ ){
            	if ( inputs[x].value != '' ){
                //inputs[x].parentNode.parentNode.classList.add('filled');
                moveLabel(inputs[x]);
              }	else {
              	replaceLabel(inputs[x]);
              }
            }
        }

        function moveLabel(input)
        {

          var name = input.getAttribute('name');

          var label = input.parentNode.querySelector('label');
          if ( label != null ){
            label.classList.add('filled');
          }
        }

        function replaceLabel(input)
        {
          var name = input.getAttribute('name');

          var label = input.parentNode.querySelector('label');
          if ( label != null ){
            label.classList.remove('filled');
          }
        }

        function setupInputs()
        {
          var inputs = document.querySelectorAll('.nh-modal-content form input:not([type="hidden"]), .nh-modal-content form textarea');
          console.log(inputs);

          if ( inputs != null ){
            var inputNum = inputs.length;
            for ( var x=0; x<inputNum; x++ ){

              if ( inputs[x].value != '' ){
                moveLabel(inputs[x]);
              }

              inputs[x].addEventListener('focus', function(){
                if ( this.value == '' ){
                  moveLabel(this);
                }
              });

              inputs[x].addEventListener('blur', function(){
                if ( this.value == '' ){
                    replaceLabel(this);
                }
                this.setAttribute('placeholder', '');
              });
            }
          }
        }


        /********/

        const closeBtn = '<div class="nh-close-btn"><button type="button"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0.533564" y1="12.412" x2="11.7922" y2="1.15341" stroke="black" stroke-width="0.8"/><line x1="0.282843" y1="0.717157" x2="11.5415" y2="11.9758" stroke="black" stroke-width="0.8"/></svg></button></div>';

        let modalBackground = document.createElement('div');
        modalBackground.classList.add('nh-modal-background');
        document.body.appendChild(modalBackground);

        setTimeout(() => {
          modalBackground.classList.add('visible');
        }, 50);


        let shareForm =
        '<div class="form-holder">'+
          '<h2>Share Wishlist</h2>'+
          '<form class="nh-share-form">'+
            '<div>'+
              '<label for="sender_name">Sender Name</label><br>'+
              '<input type="text" name="sender_name">'+
            '</div>'+
            '<div>'+
              '<label for="recipient-email">Recipient&apos;s Email</label><br>'+
              '<input type="email" name="recipient_email">'+
            '</div>'+
            '<div>'+
              '<label for="message">Message</label><br>'+
              '<textarea name="message"></textarea>'+
            '</div>'+
            '<div class="nh-button-holder">'+
            '<button class="nh-button nh-button--calypso white-bg"><span>Share Wishlist</span></button>'+
            '</div>'+
          '</form>'+
        '</div>';

        let modal = document.createElement('div');
        modal.classList.add('nh-modal-content');

        modal.innerHTML += closeBtn;
        let inner = document.createElement('div');
        inner.classList.add('inner');
        modal.appendChild(inner);
        inner.innerHTML = shareForm;


        setTimeout( () => {
          setupInputs();

          let modalCloseBtn = modal.querySelector('.nh-close-btn button');
          if ( modalCloseBtn != null ){
            modalCloseBtn.addEventListener('click', () => {
              hideShareModal();
            });
          }

          modalBackground.addEventListener('click', (e) => {
            if ( e.target.closest('.nh-modal-content') == null ){
              hideShareModal();
            }
          });




        }, 50 );

        modalBackground.appendChild(modal);


      }

      function getAllLists( options ){
        // Define success callback
        let onSuccess = function(lists) {
          // Successfully fetched all lists
          console.log("Fetched all Lists", lists);

          wishLists = lists;


          if ( wishLists.length < 1 ){
            createWishlist('My Wishlist');
            getAllLists( {init: false} );
            let lid = wishLists[0].lid;
          } else {
            let lid = wishLists[0].lid;
          }

          updateWishlistCount( wishLists[0].listcontents.length );
          showWishlistProducts();

          if ( options.init === true ){
              checkItems();
          }


        }

        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while fetching all Lists", error);
        }

        // Call `fetchLists` function
        swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });
      } //end getAllLists()

      function refreshLists(){

        let onSuccess = function(lists) {
          // Successfully fetched all lists
          console.log("Fetched all Lists", lists);
          wishLists = lists;
          updateWishlistCount( wishLists[0].listcontents.length );
        }

        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while fetching all Lists", error);
        }

        swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });
      }

      function showWishlistProducts()
      {
        console.log('showWishlistProducts() called');
        const pathname = window.location.pathname;
        if ( pathname == '/pages/wishlist' ){
          console.log('length is '+wishLists.length);
          if ( wishLists.length > 0 ){
            let lid = wishLists[0].lid;
            getListItems( lid );

          }

        }
      }


      //getAllLists();



      let radios = document.querySelectorAll('.nh-option input[type="radio"]');
      if ( radios != null ){
        [].forEach.call(radios, function( radio ) {
          radio.addEventListener('change', () => {
            console.log('change event');
            checkItems();
          });
        });
      }

      /*let options = document.querySelectorAll('.nh-option label');
      if ( options != null ){
        [].forEach.call(options, function( opt ) {
          opt.addEventListener('click', () => {
            checkItems();
          });
        });
      }*/


      function showWishlistProducts()
      {
        console.log('showWishlistProducts() called');
        const pathname = window.location.pathname;
        if ( pathname == '/pages/wishlist' ){
          console.log('length is '+wishLists.length);
          if ( wishLists.length > 0 ){
            let lid = wishLists[0].lid;
            getListItems( lid );

          }

        }
      }

      /* checkItems()
      * Check if products on dusplay are in the wishlist and displays
      * the appropriate con next to each product.
      */

      function checkItems()
      {

        ///
        lid = wishLists[0].lid;
        let contents = null
        let listConfig = {
          "lid": lid, // lid
        };

        let onSuccess = function(listContents) {
          console.log('checkItems onSuccess');

          //check each item on display against the wishlisted items
          let wishlistButtons = document.querySelectorAll('.nh-thumb-wishlist');
          if ( wishlistButtons != null ){
            [].forEach.call(wishlistButtons, function( btn ) {
              let pid = btn.getAttribute('data-pid');
              let vid = btn.getAttribute('data-vid');
              listContents.forEach( (obj) => {

                if ( pid == obj.empi && vid == obj.epi){
                  btn.classList.add('inlist');
                }

              });

            });
          }

          let productWishlistButton = document.querySelector('.nh-add-wishlist');
          if ( productWishlistButton != null ){

            //get selected variant ID
            let variantID = productWishlistButton.getAttribute('data-vid');
            let found = false;

            listContents.forEach( (obj) => {
              console.log(variantID+' => '+obj.epi);
              if ( variantID == obj.epi ){
                found = true;
              }
            });

            if ( found ){
              productWishlistButton.classList.add('inlist');
            } else {
              productWishlistButton.classList.remove('inlist');
            }
          }


        }

        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error fetching List Contents", error);
        }

        swat.fetchListCtx(listConfig, onSuccess, onError);

      }//checkItems()

      function checkItem( productID )
      {

      }

      function updateWishlistCount( num )
      {

        num = parseInt(num);
        console.log(num+' products');
        let menuLinks = document.querySelectorAll('.menu-main-menu-container.right-side ul.menu li a');
        [].forEach.call(menuLinks, function( link ) {
          console.log(link.textContent.toLowerCase());
          if ( link.textContent.toLowerCase().indexOf('wishlist') == 0 ){
            console.log('wishlist menu link found');
            let count = wishLists[0].listcontents.length;
            if ( num === 0 ){
              link.textContent = 'Wishlist';
            } else {
              link.textContent = 'Wishlist ('+num+')';
            }

          }
        });
      }

      function addToWishlist( button ){
        // Define the list id of the list
        button.disabled = true;
        let variantID = button.getAttribute('data-vid');
        let productID = button.getAttribute('data-pid');
        let productURL = 'https://' + window.location.hostname + button.getAttribute('data-url');

        var product = {
          epi: variantID, // Unique variant ID of the product
          empi: productID, // Master Product Id of the product
          du: productURL
        };

        if ( wishLists.length < 1 ){
          createWishlist('My Wishlist');
          getAllLists( {init:false} );
          let lid = wishLists[0].lid;
        } else {
          let lid = wishLists[0].lid;
        }


        let onSuccess = function (addedListItem){

          button.disabled = false;
          button.classList.add('inlist');
          getAllLists( {init:false} );
        }


        let onError = function (error){
          // Error is an xhrObj
          button.disabled = false;
          console.log("Error while adding the Product to the List", error);
        }

        let lid = wishLists[0].lid;
        if ( !checkProductInLists(variantID) ){
          swat.addToList(lid, product, onSuccess, onError);
        }

      } //addToWishlist()

    } else {
      console.log('NO SWAT');
    } // end if (swat)
}


(function onPageLoad () {

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
    console.log('SWYM started')
  }

  window.SwymCallbacks.push(onSwymLoadCallback);
})();
